import { BluetoothCoreService } from '@src/services/bluetooth/BluetoothCoreService'
import { PrintingService } from '@src/services/printing/PrintingService'
import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'

/**
 * Cross frame listener for printing. It call printing listener registered in Old seaward.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'print', etc...
 *          parameters: {object} - object containing the parameters for the print call
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function printingListener (message: any) {
    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {

    case 'print':
    /**
     * Sends print job to the connected bluetooth printer.
     */
        return PrintingService.print(params)
    case 'pair':
    /**
     * Attempts to pair a given Bluetooth device. Immediately resolves if device is already paired.
     */
        return BluetoothCoreService.pairDevice(params)
    }

    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
